<template>
  <form @submit.prevent="addCostAdjustment">
    <fieldset class="form-group">
      <label for="" class="form-label">
        Amount
      </label>
      <div class="relative rounded-md">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <span class="text-gray-400">
            {{ account.currency }}
          </span>
        </div>
        <currency-input 
          id="amount" 
          class="w-full pl-8 text-right form-input" 
          placeholder="0.00" 
          :currency="null" 
          auto-decimal-mode 
          value-as-integer 
          v-model="form.amount" />
      </div>
      <validations :errors="errors" field="name" />
    </fieldset>
    <fieldset class="form-group">
      <label for="note" class="form-label">
        Note
      </label>
      <textarea name="note" id="" cols="30" rows="2" class="form-textarea" v-model="form.note"></textarea>
      <validations :errors="errors" field="name" />
    </fieldset>
    <button class="btn btn-primary" v-submitting="submitting">
      Submit
    </button>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookingAdjustmentForm',

  props: {
    parentType: {
      type: String
    },

    parentId: {
      type: Number
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      submitting: false,
      errors: [],
      form: {
        amount: 0,
        note: ''
      }
    }
  },

  methods: {
    async addCostAdjustment () {
      try {
        this.submitting = true
        this.form[`booking_${this.parentType}_id`] = this.parentId
        await this.$api.post(`account/${this.$route.params.account}/booking-${this.parentType}-adjustments`, this.form)
        this.$emit('success')
      } catch (error) {
        console.error(error)
        this.errors = error.response.data.errors ? error.response.data.errors : []
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>